import constants from 'constants/index'

// Em projeto coberto, a aba Pendentes reúne tudo que ainda está com a organização e não foi enviado.
const isActivityInBoardTab = ({
  activityStatus,
  currentTab,
  isCoveredByReview = false,
}) => {
  const { ALL_CATEGORY_ID, PENDING_STATUS_ID, REVIEW_PENDING_STATUS_IDS } =
    constants.governanceProjectActivity

  return (
    currentTab === ALL_CATEGORY_ID ||
    activityStatus === currentTab ||
    (isCoveredByReview &&
      currentTab === PENDING_STATUS_ID &&
      REVIEW_PENDING_STATUS_IDS.includes(activityStatus))
  )
}

export default isActivityInBoardTab
